<template>
  <header class="site-header" :class="{ 'menu-open': menuOpen }">
    <div class="top">
      <router-link class="brand-link" to="/" @click="closeMenu">
        <img class="logo" src="./assets/logogth.png" alt="GTHCONSULT" />
      </router-link>

      <button
        class="menu-toggle"
        type="button"
        :aria-expanded="menuOpen ? 'true' : 'false'"
        aria-controls="main-navigation"
        aria-label="Ouvrir le menu"
        @click="menuOpen = !menuOpen"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <ul class="quick-links">
        <li>
          <a href="/#contact" @click="closeMenu">
            <font-awesome-icon icon="fa-solid fa-phone" />
            Contactez-nous
          </a>
        </li>
        <li>
          <router-link to="/catalogue" @click="closeMenu">
            <font-awesome-icon icon="fa-solid fa-handshake" />
            Catalogue
          </router-link>
        </li>
        <li>
          <router-link to="/espace-client" @click="closeMenu">
            <font-awesome-icon icon="fa-solid fa-user" />
            Espace client
          </router-link>
        </li>
      </ul>
    </div>

    <nav id="main-navigation" class="bottom" aria-label="Navigation principale">
      <ul class="main-menu">
        <li class="menu-item has-dropdown">
          <router-link to="/" @click="closeMenu">Le Groupe</router-link>
          <div class="dropdown_menu">
            <ul>
              <li><router-link :to="{ name: 'bureau-de-controle-agree-au-maroc' }" @click="closeMenu">Bureau de contrôle agréé au Maroc</router-link></li>
              <li><router-link :to="{ name: 'bureau-de-controle-a-tanger' }" @click="closeMenu">Bureau de contrôle à Tanger</router-link></li>
              <li><router-link :to="{ name: 'bureau-de-controle-a-casablanca' }" @click="closeMenu">Bureau de contrôle à Casablanca</router-link></li>
              <li><router-link :to="{ name: 'bureau-de-controle-a-kenitra' }" @click="closeMenu">Bureau de contrôle à Kénitra</router-link></li>
              <li><router-link :to="{ name: 'bureau-de-controle-a-laayoune' }" @click="closeMenu">Bureau de contrôle à Laâyoune</router-link></li>
              <li><router-link :to="{ name: 'bureau-de-controle-a-dakhla' }" @click="closeMenu">Bureau de contrôle à Dakhla</router-link></li>
              <li><router-link :to="{ name: 'bureau-de-controle-a-rabat' }" @click="closeMenu">Bureau de contrôle à Rabat</router-link></li>
              <li><router-link :to="{ name: 'bureau-de-controle-a-khouribga' }" @click="closeMenu">Bureau de contrôle à Khouribga</router-link></li>
              <li><router-link :to="{ name: 'liste-controles-reglementaires-obligatoires-maroc' }" @click="closeMenu">Liste des contrôles réglementaires obligatoires au Maroc</router-link></li>
              <li><router-link to="/a-propos" @click="closeMenu">À propos</router-link></li>
              <li><router-link to="/nos-valeurs" @click="closeMenu">Nos valeurs</router-link></li>
              <li><router-link to="/engagement" @click="closeMenu">Nos engagements</router-link></li>
            </ul>
          </div>
        </li>

        <li class="menu-item has-dropdown">
          <a href="/#services" @click="closeMenu">Nos services</a>
          <div class="dropdown_menu services-menu">
            <ul>
              <li class="has-dropdown">
                <router-link to="/controle-reglementaire-et-volontaire" @click="closeMenu">Contrôle réglementaire et volontaire</router-link>
                <div class="dropdown_menu-1">
                  <ul>
                    <li><router-link to="/controle-reglementaire-des-installations-electriques" @click="closeMenu">Installations électriques</router-link></li>
                    <li><router-link to="/controle-reglementaire-des-appareils-et-accessoires-de-levage" @click="closeMenu">Appareils et accessoires de levage</router-link></li>
                    <li><router-link to="/controle-reglementaire-des-machines-et-engins-de-chantier" @click="closeMenu">Machines et engins de chantier</router-link></li>
                    <li><router-link to="/controle-reglementaire-des-ascenseurs-escaliers-mecanique-trottoirs-roulantes" @click="closeMenu">Ascenseurs, escaliers mécaniques et trottoirs roulants</router-link></li>
                    <li><router-link to="/controle-reglementaire-des-dispositifs-de-systeme-incendie" @click="closeMenu">Systèmes incendie</router-link></li>
                    <li><router-link to="/controle-reglementaire-des-appareils-a-pression-de-gaz-et-vapeur" @click="closeMenu">Appareils à pression de gaz et de vapeur</router-link></li>
                    <li><router-link to="/controle-d-equipement-de-travail" @click="closeMenu">Équipements de travail</router-link></li>
                  </ul>
                </div>
              </li>
              <li><router-link to="/evaluation-des-risques-au-travail" @click="closeMenu">Évaluation des risques au travail</router-link></li>
              <li><router-link to="/prelevements-environnementaux" @click="closeMenu">Prélèvements environnementaux</router-link></li>
              <li class="has-dropdown">
                <router-link to="/formations-techniques" @click="closeMenu">Formations techniques</router-link>
                <div class="dropdown_menu-1 formation-menu">
                  <ul>
                    <li v-for="formation in technicalFormations" :key="formation.code">
                      <router-link :to="`/formations-techniques/${formation.slug}`" @click="closeMenu">
                        {{ formation.title }}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </li>
              <li><router-link to="/audits-et-assistance-techniques" @click="closeMenu">Audits et assistance technique</router-link></li>
            </ul>
          </div>
        </li>

        <li class="menu-item"><router-link to="/nos-moyens" @click="closeMenu">Nos moyens</router-link></li>
        <li class="menu-item"><a href="/#agrements" @click="closeMenu">Agréments</a></li>

        <li class="menu-item has-dropdown">
          <span class="nav-label">Nous rejoindre</span>
          <div class="dropdown_menu">
            <ul>
              <li><router-link to="/4-raisons-de-nous-rejoindre" @click="closeMenu">4 raisons de nous rejoindre</router-link></li>
              <li><router-link to="/offre-emploi" @click="closeMenu">Nos offres d'emploi</router-link></li>
              <li><router-link to="/candidature-spontanee" @click="closeMenu">Candidature spontanée</router-link></li>
            </ul>
          </div>
        </li>

        <li class="menu-item has-dropdown">
          <a href="/#actualites" @click="closeMenu">Actualités & médias</a>
          <div class="dropdown_menu">
            <ul>
              <li><router-link to="/actualites" @click="closeMenu">Actualités</router-link></li>
              <li><router-link to="/news-reglementation" @click="closeMenu">Actualités réglementaires</router-link></li>
            </ul>
          </div>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
import technicalFormations from '@/data/technicalFormations'

export default {
  name: "HeaderHome",
  data() {
    return {
      menuOpen: false,
      technicalFormations,
    };
  },
  watch: {
    $route() {
      this.closeMenu();
    },
  },
  methods: {
    closeMenu() {
      this.menuOpen = false;
    },
  },
};
</script>

<style scoped>
.site-header {
  position: fixed;
  inset: 0 0 auto;
  z-index: 2000;
  background: rgba(8, 16, 34, 0.82);
  backdrop-filter: blur(12px);
  color: #fff;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);
}

.top {
  width: min(100% - 32px, 1240px);
  min-height: 74px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
}

.brand-link {
  flex: 0 0 auto;
}

.logo {
  width: clamp(94px, 12vw, 140px);
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.25));
}

.quick-links,
.main-menu,
.dropdown_menu ul,
.dropdown_menu-1 ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.quick-links {
  display: flex;
  align-items: center;
  gap: 10px;
}

.quick-links a {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 38px;
  padding: 0 12px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
}

.quick-links li:nth-child(2) a {
  background: #1a73e8;
  border-color: #1a73e8;
}

.quick-links li:nth-child(3) a {
  background: #56be25;
  border-color: #56be25;
}

.menu-toggle {
  display: none;
  width: 44px;
  height: 44px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  cursor: pointer;
}

.menu-toggle span {
  display: block;
  width: 22px;
  height: 2px;
  margin: 5px auto;
  background: currentColor;
  border-radius: 999px;
}

.bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.main-menu {
  width: min(100% - 32px, 1240px);
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: stretch;
}

.menu-item {
  position: relative;
}

.menu-item > a,
.menu-item > .nav-label {
  display: flex;
  align-items: center;
  min-height: 48px;
  padding: 0 14px;
  color: #fff;
  font-size: 15px;
  font-weight: 800;
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
}

.menu-item:hover > a,
.menu-item:hover > .nav-label {
  color: #8ee264;
}

.dropdown_menu,
.dropdown_menu-1 {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 320px;
  background: #fff;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.22);
  overflow: visible;
}

.services-menu {
  min-width: 420px;
}

.dropdown_menu-1 {
  top: 0;
  left: 100%;
  background: #243064;
}

.formation-menu {
  width: 420px;
  max-height: min(70vh, 640px);
  overflow-y: auto;
}

.has-dropdown:hover > .dropdown_menu,
.dropdown_menu li:hover > .dropdown_menu-1 {
  display: block;
}

.dropdown_menu li,
.dropdown_menu-1 li {
  position: relative;
}

.dropdown_menu a,
.dropdown_menu-1 a {
  display: block;
  padding: 11px 16px;
  color: #12315f;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.35;
  text-decoration: none;
}

.dropdown_menu-1 a {
  color: #fff;
}

.dropdown_menu a:hover,
.dropdown_menu-1 a:hover {
  background: rgba(86, 190, 37, 0.14);
}

@media (max-width: 980px) {
  .top {
    min-height: 64px;
  }

  .menu-toggle {
    display: block;
    order: 3;
  }

  .quick-links {
    margin-left: auto;
    gap: 6px;
  }

  .quick-links a {
    width: 40px;
    padding: 0;
    justify-content: center;
    font-size: 0;
  }

  .quick-links svg {
    font-size: 15px;
  }

  .bottom {
    display: none;
    max-height: calc(100vh - 64px);
    overflow-y: auto;
    border-top: 1px solid rgba(255, 255, 255, 0.18);
    background: rgba(8, 16, 34, 0.98);
  }

  .menu-open .bottom {
    display: block;
  }

  .main-menu {
    width: 100%;
    display: block;
  }

  .menu-item {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .menu-item > a,
  .menu-item > .nav-label {
    min-height: 46px;
    padding: 0 18px;
    font-size: 14px;
    white-space: normal;
  }

  .dropdown_menu,
  .dropdown_menu-1 {
    position: static;
    display: block;
    min-width: 0;
    border-radius: 0;
    box-shadow: none;
    background: rgba(255, 255, 255, 0.06);
  }

  .dropdown_menu-1 {
    background: rgba(86, 190, 37, 0.14);
  }

  .formation-menu {
    width: auto;
    max-height: none;
    overflow: visible;
  }

  .dropdown_menu a,
  .dropdown_menu-1 a {
    padding: 10px 28px;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
  }

  .dropdown_menu-1 a {
    padding-left: 42px;
  }
}

@media (max-width: 520px) {
  .top {
    width: calc(100% - 20px);
    gap: 8px;
  }

  .quick-links li:first-child {
    display: none;
  }

  .logo {
    width: 92px;
  }
}
</style>
